import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ZuiThreeDotsModule } from '@zerops/zui/three-dots';

import { L7ConfigDialogFeature } from './l7-config-dialog.feature';
import { L7ConfigFormComponent } from './components/l7-config-form.component';
import { L7ConfigDialogEffect } from './l7-config-dialog.effect';

@NgModule({
  declarations: [
    L7ConfigDialogFeature
  ],
  imports: [
    CommonModule,
    ZefDialogModule,
    ZefScrollbarComponent,
    ZefProgressErrorModule,
    MatButtonModule,
    ZuiThreeDotsModule,
    L7ConfigFormComponent, // Standalone component import
    EffectsModule.forFeature([L7ConfigDialogEffect])
  ],
  exports: [
    L7ConfigDialogFeature
  ]
})
export class L7ConfigDialogModule {}